import { useMemo } from "react";
import { useTranslation } from "react-i18next";

function useStatusFlagOption() {

    const { t } = useTranslation();
    const statusOptions = [
        { value: '', key: "all" },
        { value: 'ACTIVE', key: "active" },
        { value: 'INACTIVE', key: "inactive" },
    ];
    const modifiedStatus = useMemo(() => {
        const dropdown = statusOptions.map((opt) => ({
            ...opt,
            label: opt.key !== 'all' ? t(`status.${opt.key}`) : t('status.all'),
            value: opt.value,
            statusFlag: opt.key,
        }))
        return dropdown

    }, [statusOptions])



    return {
        modifiedStatus
    }
}

export default useStatusFlagOption;
